/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  account: {},
  id: null,
  error: null,
};

const getters = {
  account: state => state.account,
  id: state => (state.account ? state.account.id : null),
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/accounts/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.error);
      });
  },
  save({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request = null;
    if (payload.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/accounts/${payload.account.id}`, payload.account);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/accounts/`, payload.account);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.error);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/accounts/${payload.id}/partner/${payload.partner}`)
      .then(() => {
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.error);
      });
  },
  setPassword({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/accounts/${payload.accountId}/password`, payload.data)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, account) {
    state.account = account.body;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  [mTypes.CLEAR_STATE](state) {
    state.account = {};
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/accounts/account.js